export default "__VITE_ASSET__CgANpqw$__"